import { EReportColumnHeader } from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalTables } from '../../../models'
import { daMetricHeaders } from './da-metric-headers'

export const daAudienceMetricHeaders: Array<TGlobalTables> =
  daMetricHeaders.filter(
    (header) =>
      !(
        header === EReportColumnHeader.ShareOfVoice ||
        header === EReportColumnHeader.WinRate
      )
  )
